import type { NavigationTreeItem } from '@scayle/storefront-nuxt'
import { computed } from 'vue'
import { useCurrentShop, useRpc } from '#storefront/composables'
import { useI18n } from '#i18n'
import { NAVIGATION_IDS_DEV, NAVIGATION_IDS_PROD } from '~/constants'
import { useRuntimeConfig } from '#app'

export async function useFooterData(params?: unknown) {
  const { t } = useI18n()
  const config = useRuntimeConfig()
  const currentShop = useCurrentShop()

  const NAVIGATION_ID_MAP_CONFIG: Record<string, number> =
    config.public.appEnv === 'production'
      ? NAVIGATION_IDS_PROD
      : NAVIGATION_IDS_DEV

  const menuName = computed(() => {
    return `Navigation ${currentShop.value.countryCode} - Footer`
  })

  const { data: navigationTree } = await useRpc(
    'getNavigationTreeById' as any,
    `footer-navigation-${currentShop.value.countryCode}`,
    {
      navigationId: NAVIGATION_ID_MAP_CONFIG[menuName.value],
      params: params || {
        with: { category: true },
      },
    },
  )

  const navigationColumns =
    navigationTree.value?.items?.find(
      (item: NavigationTreeItem) => item.name === t('footer.navigation'),
    )?.children || []

  const payments =
    navigationTree.value?.items?.find(
      (item: NavigationTreeItem) => item.name === t('footer.payment_methods'),
    )?.children || []

  const followUs =
    navigationTree.value?.items?.find(
      (item: NavigationTreeItem) => item.name === t('footer.follow_us'),
    )?.children || []

  const topCategories =
    navigationTree.value?.items?.find(
      (item: NavigationTreeItem) =>
        item.name === t('footer.promises.top_categories'),
    )?.children || []

  return {
    navigationTree,
    navigationColumns,
    payments,
    followUs,
    topCategories,
  }
}
